import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { observe } from "./observe.js";
function useInView(options = {}) {
  const {
    skip,
    root,
    delay,
    onChange,
    threshold,
    rootMargin,
    triggerOnce,
    initialInView,
    fallbackInView,
    trackVisibility
  } = options;
  const rUnobserve = useRef();
  const rOnChange = useRef();
  useLayoutEffect(() => void (rOnChange.current = onChange), [onChange]);
  const [{ inView, entry }, setState] = useState(() => ({ inView: !!initialInView }));
  const thresholdAsString = Array.isArray(threshold) ? threshold.toString() : threshold;
  const rThreshold = useRef(threshold);
  useLayoutEffect(() => void (rThreshold.current = threshold), [threshold]);
  const setRef = useCallback(
    (node) => {
      if (thresholdAsString) null;
      rUnobserve.current?.();
      rUnobserve.current = void 0;
      if (skip) return;
      if (node) {
        rUnobserve.current = observe(
          node,
          (inView2, entry2) => {
            setState({ inView: inView2, entry: entry2 });
            if (rOnChange.current) rOnChange.current(inView2, entry2);
            if (entry2.isIntersecting && triggerOnce && rUnobserve.current) {
              rUnobserve.current();
              rUnobserve.current = void 0;
            }
          },
          {
            root,
            // @ts-expect-error
            delay,
            threshold: rThreshold.current,
            rootMargin,
            trackVisibility
          },
          fallbackInView
        );
      }
    },
    [root, skip, delay, rootMargin, triggerOnce, fallbackInView, trackVisibility, thresholdAsString]
  );
  useEffect(() => {
    if (!rUnobserve.current && entry && !triggerOnce && !skip) {
      setState({ inView: !!initialInView });
    }
  });
  return { ref: setRef, inView, entry };
}
export {
  useInView
};
//# sourceMappingURL=useInView.js.map
